import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Claude / XAES Analyst per-user settings. Phase 4 wires these into
 * the Vercel-AI-SDK-backed chat hook. Persisted in localStorage so
 * each facilitator's model choice survives reloads.
 *
 * Default is Haiku 4.5 — the fastest + cheapest tier, and the most
 * forgiving on Anthropic's per-minute rate limits (especially on
 * fresh / low-tier workspace keys). Facilitators can switch to
 * Sonnet or Opus via the settings modal when they need deeper
 * synthesis.
 */

type ClaudeSettingsState = {
  model: "claude-haiku-4-5" | "claude-sonnet-4-6" | "claude-opus-4-7";
  apiKeyOverride: string | null;
  setModel: (model: ClaudeSettingsState["model"]) => void;
  setApiKeyOverride: (key: string | null) => void;
};

export const useClaudeSettings = create<ClaudeSettingsState>()(
  persist(
    (set) => ({
      model: "claude-haiku-4-5",
      apiKeyOverride: null,
      setModel: (model) => set({ model }),
      setApiKeyOverride: (apiKeyOverride) => set({ apiKeyOverride }),
    }),
    {
      name: "xaes-claude-settings",
      // Bump on default change so existing facilitators (who were
      // pinned to Sonnet 4.6 by the previous default) get re-defaulted
      // to Haiku rather than carrying the heavier model forward.
      // They can still pick Sonnet / Opus via the settings modal.
      version: 2,
    }
  )
);
